import type User from '@this/domain/user/user';
import React, { useEffect, useState } from 'react';
import HamburgerButton from '@this/shared/header/hamburger_button';
import { styled } from '@this/constants/themes';
import NavContantSm from '@this/shared/header/nav_content_sm';
import type { CurrentMembershipResponseArgs } from '@this/shared/header/organization_switcher';
import { useLocation } from 'react-router';

interface Props {
  user?: User | null;
  currentMembership: CurrentMembershipResponseArgs | null;
  appliedCount: number;
  unreadMessagesCount: number;
}

const HeaderContentSm: React.FC<Props> = ({ user, currentMembership, appliedCount, unreadMessagesCount }) => {
  const [active, setActive] = useState(false);
  const location = useLocation();

  const close = () => {
    document.body.removeAttribute('style');
    setActive(false);
  };

  const open = () => {
    document.body.style.overflow = 'hidden';
    setActive(true);
  };

  useEffect(close, [location]);

  return (
    <>
      <Container>
        <HamburgerButton active={active} onClick={() => (active ? close() : open())} />
      </Container>
      {user && (
        <StyledNav
          user={user}
          currentMembership={currentMembership}
          active={active}
          appliedCount={appliedCount}
          unreadMessagesCount={unreadMessagesCount}
        />
      )}
    </>
  );
};

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  margin-right: 10px;
`;

const StyledNav = styled(NavContantSm)<{ active: boolean }>`
  left: ${({ active }) => (active ? 0 : '100%')};
  opacity: ${({ active }) => (active ? 1 : 0)};
  transition: opacity 0.3s, left 0.3s;
`;

export default HeaderContentSm;
